import { Box, Container, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import { APP_ID } from "../../config/constants";
import { createVideosService } from "../../services/video";
import Information from "./Information";
import Interactive from "./Interactive";

const CreateVideo = () => {
  const navigate = useNavigate();

  const [step, currentStep] = useState("Information");
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    name: "",
    description: "",
    categoryIds: [],
    features: [],
    cover: "",
    poster: "",
  });

  const next = async (vals) => {
    setValues({ ...values, ...vals });
    if (step === "Information") return currentStep("Interactive");
    if (step === "Interactive") {
      setLoading(true);
      const page = {
        ...values,
        ...vals,
        appId: APP_ID,
      };
      page.features = page.features.filter(
        (feature) =>
          feature.typeId !== "" &&
          feature.typeId !== null &&
          feature.typeId !== undefined
      );
      console.log("vals", page);

      let formData = new FormData();

      page.poster.file && formData.append("poster", page.poster.file);
      page.cover.file && formData.append("video", page.cover.file);
      page.appId && formData.append("appId", page.appId);
      page.name && formData.append("name", page.name);
      page.description && formData.append("description", page.description);

      page.categoryIds?.forEach((e) => {
        formData.append("categoryIds[]", e);
      });
      page.features?.forEach((e, i) => {
        e?.typeId && formData.append(`features[${i}][typeId]`, e?.typeId);
        e?.entityId && formData.append(`features[${i}][entityId]`, e?.entityId);
        e?.videoPause &&
          formData.append(`features[${i}][videoPause]`, e?.videoPause);
        e?.duration && formData.append(`features[${i}][duration]`, e?.duration);
        e?.position && formData.append(`features[${i}][position]`, e?.position);
        e?.startTime &&
          formData.append(`features[${i}][startTime]`, e?.startTime);
      });
      createVideosService({
        sendData: formData,
        cb: (err) => {
          setLoading(false);
          if (!err) {
            navigate("/");
          }
        },
      });
    }
  };

  return (
    <>
      <Container maxWidth={"xl"} sx={{ mt: 3 }}>
        <Grid container>
          <Grid item xs={12} lg={6}>
            <Box
              sx={{
                width: 1,
                height: "80vh",
                backgroundImage: "url(/images/layout/photos.png)",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                position: "relative",

                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                flexDirection: "column",
              }}
            >
              <Box sx={{ position: "absolute", top: 250, left: 50 }}>
                <Typography color={"#F2F2F2"} variant="subtitle1">
                  Interactive video
                </Typography>
                <Typography color={"#FFFFFF"} variant="h4" fontWeight={700}>
                  Unlimited creativity
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Typography variant="h6" fontWeight={500}>
              Create Interactive video
            </Typography>

            {step === "Information" && (
              <Information next={next} values={values} />
            )}

            {step === "Interactive" && (
              <Interactive
                next={next}
                values={values}
                currentStep={currentStep}
                loading={loading}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CreateVideo;
